import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const NoCatchDialog = ({ msgIdx, handleClick }) => {
  const message = [
    `There are no efforts records for this trip. Please make appropriate changes \
    by adding effort records or change the trip to a no effort trip with applicable \
    activity.`,
    `There are efforts without any catch records. Please make appropriate changes \
    by adding catch records or change the trip to a no effort trip with applicable \
    activity.`,
  ];
  const handleClose = (e) => {
    handleClick(e);
  };

  return (
    <div>
      <Dialog
        open={true}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Can not submit Report!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message[msgIdx]}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={(e) => handleClose(e)}
            color="primary"
            autoFocus
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NoCatchDialog;
